module.exports = __webpack_public_path__ + "img/cartoon_bengda.e4b2526a.png";